var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c("div", { staticClass: "deal-banner-bg" }, [
        _c("div", { staticClass: "container-max" }, [
          _c("div", { staticClass: "deal-banner d-none d-md-flex" }, [
            _c("div", { staticClass: "deal-banner__countdown" }, [
              _c("div", { staticClass: "time-box" }, [
                _c("span", { staticClass: "time-box__value" }, [
                  _vm._v(_vm._s(_vm.formattedTime.days)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "time-box__label" }, [
                  _vm._v("DAYS"),
                ]),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "time-separator" }, [_vm._v(":")]),
              _vm._v(" "),
              _c("div", { staticClass: "time-box" }, [
                _c("span", { staticClass: "time-box__value" }, [
                  _vm._v(_vm._s(_vm.formattedTime.hours)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "time-box__label" }, [_vm._v("HRS")]),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "time-separator" }, [_vm._v(":")]),
              _vm._v(" "),
              _c("div", { staticClass: "time-box" }, [
                _c("span", { staticClass: "time-box__value" }, [
                  _vm._v(_vm._s(_vm.formattedTime.minutes)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "time-box__label" }, [
                  _vm._v("MINS"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "deal-banner__content" }, [
              _c("div", { staticClass: "deal-banner__headline" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.dealName.toUpperCase()) +
                    ":\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "deal-banner__text" }, [
                _vm._v("\n        " + _vm._s(_vm.description) + "\n      "),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "deal-banner__code",
                class: { "deal-banner__code--copied": _vm.copied },
                attrs: { type: "button" },
                on: { click: _vm.copyCode },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.copied ? _vm.copiedText : _vm.code) +
                    "\n    "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "deal-banner d-md-none" }, [
            _c("div", { staticClass: "deal-banner__content" }, [
              _c("div", { staticClass: "deal-banner__headline" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.dealName.toUpperCase()) +
                    ":\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "deal-banner__text" }, [
                _vm._v("\n        " + _vm._s(_vm.description) + "\n      "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex deal-banner__mobile-content" }, [
              _c("div", { staticClass: "deal-banner__countdown" }, [
                _c("div", { staticClass: "time-box" }, [
                  _c("span", { staticClass: "time-box__value" }, [
                    _vm._v(_vm._s(_vm.formattedTime.days)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "time-box__label" }, [
                    _vm._v("DAYS"),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "time-separator" }, [_vm._v(":")]),
                _vm._v(" "),
                _c("div", { staticClass: "time-box" }, [
                  _c("span", { staticClass: "time-box__value" }, [
                    _vm._v(_vm._s(_vm.formattedTime.hours)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "time-box__label" }, [
                    _vm._v("HRS"),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "time-separator" }, [_vm._v(":")]),
                _vm._v(" "),
                _c("div", { staticClass: "time-box" }, [
                  _c("span", { staticClass: "time-box__value" }, [
                    _vm._v(_vm._s(_vm.formattedTime.minutes)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "time-box__label" }, [
                    _vm._v("MINS"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "deal-banner__code",
                  class: { "deal-banner__code--copied": _vm.copied },
                  attrs: { type: "button" },
                  on: { click: _vm.copyCode },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.copied ? _vm.copiedText : _vm.code) +
                      "\n      "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }